import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_loai_nganhang, Lists_loaiquy} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-dm-nganhangedit',
  templateUrl: './nganhangedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./nganhangedit.component.scss'],
    providers: [ListService, Repository]
})


export class nganhangeditComponent implements OnInit {

   
    
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputloaitaikhoans: any;
  inputloaiquys: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null, Dia_Chi: null, Ghi_Chu: null, Parent: null, Trang_Thai: null
    , Nhom_Doi_Tuong_ID: null, Don_Vi_Id: null, Ma_Ao: null, Ma_Cap_Ngan_Sach: null, Mo_Tai_Kho_Bac: null
    , Loai_Tai_Khoan_Id: null, Loai_Quy_Id: null, Chi_Nhanh: null, Ma_So_Thue: null
  };    
    nhomdtid:string=null;
  hoatdong: string = null;
  callform: any = null;

  @ViewChild('slLoaiKhoan', { static: false }) slLoaiKhoan: NgSelectComponent;
  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();
 
  
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;

  loadDataInit(nhomdoituongid: string, id: string, donviid: string, tcallform: any) {

    this.callform = tcallform;

    //if (nhomdoituongid.toLocaleUpperCase() == "5E79BF59-78D9-4C54-8EF7-0A242F5CBC24")
    //  this.hoatdong = "Ngừng theo dõi"
    //else
      this.hoatdong = "Hoạt động"

          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            let data = JSON.parse(authlogin);
            var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
            if (giatri != null && giatri.length > 0) {
              if (giatri[0].them == true)
                this.quyen_them = true;
              else
                this.quyen_them = false;
              if (giatri[0].sua == true)
                this.quyen_sua = true;
              else
                this.quyen_sua = false;
              if (giatri[0].xoa == true)
                this.quyen_xoa = true;
              else
                this.quyen_xoa = false;
            }
          }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
        },500);
        this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/null/'+donviid)
        .subscribe(response => {            
            this.inputparents=response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_loai_nganhang.id, MaGiaoDien: '', DonViId: donviid })
      .subscribe(response => {
        this.inputloaitaikhoans = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_loaiquy.id, MaGiaoDien: '', DonViId: donviid })
      .subscribe(response => {
        this.inputloaiquys = response;
      });
    this.doituongSelect = {
      Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null, Dia_Chi: null, Ghi_Chu: null, Parent: null, Trang_Thai: null
      , Nhom_Doi_Tuong_ID: nhomdoituongid, Don_Vi_Id: donviid, Ma_Ao: null, Ma_Cap_Ngan_Sach: null, Mo_Tai_Kho_Bac: null
      , Loai_Tai_Khoan_Id: null, Loai_Quy_Id: null, CallForm: null, Chi_Nhanh: null, Ma_So_Thue: null
    };    
      
        
        if(id === null)
        {
            console.log("vao loaddatainit" + id);
            this.repo.getRequest("api/doituong/SinhMaDoiTuong/" + nhomdoituongid + '/'+donviid)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Ma_Doi_Tuong = response;
            });
          this.doituongSelect.Trang_Thai = true;
        }
        else {
          console.log("t11");
          this.repo.getRequest("api/doituongnganhang/getbyid/" + id)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Id = id;
                this.doituongSelect.Ma_Doi_Tuong = response.Ma_Doi_Tuong;
                this.doituongSelect.Ten_Doi_Tuong = response.Ten_Doi_Tuong;
                this.doituongSelect.Trang_Thai = response.Trang_Thai;
                this.doituongSelect.Ghi_Chu = response.Ghi_Chu;
                this.doituongSelect.Parent = response.Parent;
                this.doituongSelect.Ma_Ao = response.Ma_Ao;
              this.doituongSelect.Mo_Tai_Kho_Bac = response.Mo_Tai_Kho_Bac;
              this.doituongSelect.Dia_Chi = response.Dia_Chi;
              this.doituongSelect.Loai_Tai_Khoan_Id = response.Loai_Tai_Khoan_Id;
              this.doituongSelect.Loai_Quy_Id = response.Loai_Quy_Id;
              this.doituongSelect.Ma_Cap_Ngan_Sach = response.Ma_Cap_Ngan_Sach;
              this.doituongSelect.Chi_Nhanh = response.Chi_Nhanh;
              this.doituongSelect.Ma_So_Thue = response.Ma_So_Thue;
              }); 
        }
        
       
  }
  keyDiaChiPress(event: any) {
    if (event.which === 13) {
      this.slLoaiKhoan.focus();
      event.preventDefault();
    }
  }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
  public closeModal() {
    console.log(this.save);
    
    
    this.save.emit(null);
    
    }
    public saveproduct() {
        if (this.doituongSelect.Ten_Doi_Tuong == null || this.doituongSelect.Ten_Doi_Tuong == "") {
            swal('Lỗi!', 'Vui lòng nhập tên đối tượng!.', 'error');
            return;
      }
      $('#loading').show();
        this.repo.postRequest("api/doituongnganhang/addorupdate",this.doituongSelect)
            .subscribe(response => {  
              console.log(response);
              $('#loading').hide();
              if (response != null && response.match('-')) {
                this.doituongSelect.Id = response;
                this.doituongSelect.CallForm = this.callform;
                this.save.emit(this.doituongSelect);
                
              }
              else {
                swal('Lỗi!', response, 'error');
              }
             
            }); 
    }
   
    
   

   


}
